import React from "react";

export default function TermsPage() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold text-[#000099] mb-6">
        Leievilkår for Ryfylke Utleie
      </h1>

      <h2 className="text-xl font-semibold mt-6 mb-2">Alder og førerkort</h2>
      <p>
        Minimumsalder for å leie bil er 23 år. Man må også ha hatt gyldig
        førerkort sammenhengende i minst 2 år. Unntak fra krav om alder og
        førerkort kan gjøres der organisasjoner/bedrifter leier bilen og har
        yngre sjåfører. Dette må avtales på forhånd. Vær oppmerksom på at dette
        kan gi andre vilkår for forsikringer og egenandeler. Ved spesielle
        biltyper har vi høyere aldersgrenser. Gyldig førerkort må fremvises.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Selvrisiokodekning</h2>
      <p>
        Våre utleiepriser inkluderer forsikring. Alle leieforhold har egenandel
        ved skade.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Henting / levering</h2>
      <p>Etter avtale.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Bomveier / Autopass</h2>
      <p>
        Bompasseringer belastes etterskuddsvis. Bompasseringer er mva-pliktige.
        Ved passeringer i andre bomstasjoner må våre kunder, der det er mulig,
        kjøre gjennom på “Manuell” eller “Mynt” og betale selv. Ved feilpassering
        tilkommer gebyr i tillegg til passeringprisen.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Parkeringsgebyr</h2>
      <p>
        Dersom du blir ilagt gebyr for feilparkering er dette ditt ansvar, og
        gebyr/bot må betales omgående. Manglende betaling av parkeringsgebyr vil
        medføre et krav mot deg personlig.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Leietakers ansvar</h2>
      <p>
        Leietaker bærer fullt ansvar for kjøretøyet og bruken av det som om han
        var eier. Dette inkluderer trafikkforseelser, skader og parkering.
        Skader, tyveri, brann eller hærverk skal straks meldes til utleier eller
        politi. Leietaker er fullt erstatningspliktig for skader dersom det er
        utvist grov uaktsomhet.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Selvrisiko-dekning</h2>
      <p>
        Leietakers egenandel kan reduseres dersom selvrisiko-dekning (C.D.W.
        eller T.P.) tegnes. Dette må stå på kontrakten for å være gyldig. Unntak
        gjelder ved uaktsom kjøring, feil bruk, lasteskader, rygging uten
        hjelpemann, felgskader, snøras-skader, snøkjettinger brukt feil, eller
        kjøring utenfor offentlig vei uten avtale.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Leietakers plikter</h2>
      <p>
        Leietaker plikter å behandle kjøretøyet på forsvarlig måte og ikke bruke
        det til ulovlig kjøring, øvelseskjøring, billøp, konkurranser eller taue
        andre. Kjøretøyet må ikke overlates til andre enn avtalte sjåfører. Det
        er forbudt å kjøre i påvirket tilstand. Bilen skal ikke overlates ulåst
        eller lastes for tungt.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Tekniske feil</h2>
      <p>
        Ved tekniske feil skal utleier kontaktes umiddelbart. Reparasjoner
        håndteres av utleier. Dersom kjøretøyet ikke kan repareres innen rimelig
        tid, kan utleier tilby nytt kjøretøy eller avslutte leieforholdet.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        Økonomiske forhold og betaling
      </h2>
      <ul className="list-disc ml-6">
        <li>Leiebeløpet forfaller ved henting.</li>
        <li>
          Avbestilling: Gratis inntil 3 dager før. 50 % belastes etter dette.
          Full pris ved uteblivelse.
        </li>
        <li>
          Kjøretøy utleveres med full tank og skal returneres med full tank.
          Manglende drivstoff faktureres med pumpepris + gebyr.
        </li>
        <li>
          Bøter/avgifter skal betales umiddelbart. Ubetalte bøter tillegges 100
          % gebyr.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Ansvarsfraskrivelse</h2>
      <p>
        Utleier fraskriver seg ansvar for tap av tid, penger eller eiendeler
        under leieperioden. Utleier er ikke ansvarlig for gjenstander igjen i
        bilen.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Tvister</h2>
      <p>
        Norsk lov gjelder. Eventuelle tvister avgjøres i Sør-Rogaland tingrett.
      </p>
    </div>
  );
}
